import React from "react";

const counters = [
  {
    value: "150k+",
    label: "Students Enrolled",
    icon: "🎓",
  },
  {
    value: "25k+",
    label: "Total Courses",
    icon: "📚",
  },
  {
    value: "120+",
    label: "Expert Tutors",
    icon: "👨‍🏫",
  },
  {
    value: "50+",
    label: "Win Awards",
    icon: "🏆",
  },
];

function CounterSection() {
  return (
    <section className="counter-area">
      <div className="container">
        <div className="row g-4 text-center">
          {counters.map((item, index) => (
            <div className="col-6 col-md-3" key={index}>
              <div className="counter-box">
                <div className="counter-icon">{item.icon}</div>
                <h3 className="counter-value">{item.value}</h3>
                <p className="counter-label">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CounterSection;
